import { FormControl, FormField, FormItem } from '@/components/ui/Form';
import { Input } from '@/components/ui/Input';
import { validateBuildingNumber } from '@/features/v2/summaryForms/Validate';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const OWNER_BUILDING_NUMBER_NAME = 'owner.building_number';
export const OWNER_BUILDING_NUMBER_COMPANY_NAME =
  'owner.building_number_company';

const InputBuildingNumber = ({
  name = OWNER_BUILDING_NUMBER_NAME,
  focused,
  setFocused,
  disabled,
  autoCompleteOff = false,
}: {
  name: string;
  focused: string;
  setFocused: (value: string) => void;
  disabled?: boolean;
  autoCompleteOff?: boolean;
}) => {
  const { i18n } = useLingui();
  const { trigger } = useFormContext();

  return (
    <FormField
      name={name}
      rules={{
        validate: (value: string) => validateBuildingNumber(value),
      }}
      render={({ field, fieldState }) => {
        const { onChange, onBlur, ...restField } = field;

        return (
          <FormItem className="col-span-2">
            <FormControl>
              <Input
                autoComplete={autoCompleteOff ? 'none' : 'address-line2'}
                label={i18n.t('Nr budynku')}
                disabled={disabled}
                error={
                  !disabled && fieldState.error?.message
                    ? fieldState.error?.message
                    : undefined
                }
                success={
                  focused !== field.name &&
                  !fieldState.error?.message &&
                  field.value
                }
                onChange={(e) => {
                  onChange(e);
                  if (fieldState.error) {
                    trigger(field.name);
                  }
                }}
                onBlur={() => {
                  trigger(field.name);
                  setFocused('');
                  onBlur();
                }}
                onFocus={() => setFocused(field.name)}
                {...restField}
              />
            </FormControl>
          </FormItem>
        );
      }}
    />
  );
};

export default InputBuildingNumber;
